export const onboardingKnowledgeBase = {
  updates: 'https://weavrau.zendesk.com/hc/en-au/articles/16051063269391-View-Updates',
  focusAreas: 'https://weavrau.zendesk.com/hc/en-au/articles/16040719173263-Focus-Areas',
  respond: 'https://weavrau.zendesk.com/hc/en-au/articles/15533336538895-Respond-to-a-Signal',
  share: 'https://weavrau.zendesk.com/hc/en-au/articles/16051000492559-Share-an-update',
  strategy: 'https://weavrau.zendesk.com/hc/en-au/articles/16062353064463-What-is-a-Strategy',
  strategyDetails: 'https://weavrau.zendesk.com/hc/en-au/articles/15138484470159-Managing-Actions-and-Deliverables',
  insights: 'https://weavrau.zendesk.com/hc/en-au/articles/15057894095887-Viewing-Strategy-Reports-and-Insights',
  review: 'https://weavrau.zendesk.com/hc/en-au/articles/16190491560591-Reviewing-and-Approving-Updates',
  workflows: 'https://weavrau.zendesk.com/hc/en-au/articles/16176958055183-Assigning-Responsibility-to-Users',
  collaborate: 'https://weavrau.zendesk.com/hc/en-au/articles/13407355092879-How-to-share-updates-from-weavr',
  subscription: 'https://weavrau.zendesk.com/hc/en-au/articles/13407510038799-Subscription-administration',
  profile: 'https://weavrau.zendesk.com/hc/en-au/articles/13407589875215-How-to-Edit-Profile-Details'
} as const;

export const getOnboardingKnowledgeBaseLink = (pathname: string): string => {
  if (pathname.startsWith('/updates/review')) return onboardingKnowledgeBase.review;
  if (pathname.startsWith('/updates')) return onboardingKnowledgeBase.updates;
  if (pathname.startsWith('/collaborate')) return onboardingKnowledgeBase.collaborate;
  if (pathname.startsWith('/sstra/')) return onboardingKnowledgeBase.strategyDetails;
  if (pathname.startsWith('/sstra')) return onboardingKnowledgeBase.strategy;
  if (pathname.startsWith('/report/our_journey')) return onboardingKnowledgeBase.insights;
  if (pathname.startsWith('/admin/subscription')) return onboardingKnowledgeBase.subscription;
  if (pathname.startsWith('/profile')) return onboardingKnowledgeBase.profile;
  return 'https://weavrau.zendesk.com/hc/en-au';
};
